<!--
 * @Author: your name
 * @Date: 2021-03-11 16:03:07
 * @LastEditTime: 2021-08-03 16:20:01
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \mooklook_phone\src\views\AOG.vue
-->

<template>
  <div class="about_us">
    <div :style="{minHeight:height+'px'}" style="padding-top:1px">
     <div class="us_address" v-if="articleList &&articleList.length>0">
        <div class="address_list" v-for="(item,index) in articleList" :key="index">
          <div class="title">
            <span>{{item.title}}</span>
          </div>
          <div class="msg">{{item.description}}</div>
        </div>
      </div> 
      <!--  <div class="us_images clear">
        <div class="img fl" v-for="(item,index) in imageList" :key="index">
          <img class="auto-img" :src="item.imageUrl" />
        </div>
      </div>-->
      <div class="us_images clear">
        <div class="imgW fl" v-for="(item,index) in imageList" :key="index">
          <img class="auto-img" :src="item.imageUrl" />
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import Footer from "@/components/Footer";
import { carouselByTitle, getArticleList } from "@/api/api";
export default {
  components: {Footer},
  // 定义属性
  data() {
    return {
      imageList: [],
      articleList: [],
      height: 0,
      isPhone: document.body.clientWidth < 920,
    };
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    getCarouselByTitle() {
      let title = "联系我们";
      let params = {
        title: title || "",
      };
      carouselByTitle(params)
        .then((res) => {
          if (res.data.code == 0) {
            //JPN -日文版
            //Ch   -中文版
              let data= res.data.data;
            let imageList=[]
            let langeNot= this.lange == "Ch" ? "日文版" : "中文版";
            data.forEach(item=>{
              if(!item.title || item.title.indexOf(langeNot)<0){
                imageList.push(item)
              }
            })
            this.imageList =imageList;
          }
        })
        .catch((err) => {});
    },
    getArticleList(min = 1, max = 6) {
      let params = {
        articleTypeId: this.lange == "Ch" ? 51 : 53,
        pageIndex: min,
        pageSize: max,
      };
      getArticleList(params).then((res) => {
        this.articleList = res.data.data.data;
      });
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getCarouselByTitle();
    this.getArticleList();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
   // let height = this.isPhone ? 233 : 427;
   let height = this.isPhone ? 243 : 447;
    this.height = window.screen.availHeight - height;
  },
};
</script>

<style lang='less' scoped>
.about_us {
  .us {
    &_address {
      .address_list {
        border: 1px solid #ededed;
        text-align: center;
        .title {
          font-weight: bold;
          color: #3e3a39;
          span {
            display: inline-block;
          }
        }
        .msg {
          font-weight: 400;
          color: #878787;
        }
      }
    }
    &_images {
      .imgW{display: inline-block;width: 100%;height: auto;}
      .img {
        overflow: hidden;
      }
      .img:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
}
</style>
